var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { downloadBlob } from '../utils';
import { useAlertServiceClient } from './useAlertServiceClient';
export function useAlertAttachments(rootAttachments, updateForm) {
    const [attachments, setAttachments] = React.useState(rootAttachments !== null && rootAttachments !== void 0 ? rootAttachments : []);
    const alertsClient = useAlertServiceClient();
    const [isLoading, setIsLoading] = React.useState(false);
    const [loadingEmailAttachments, setLoadingEmailAttachments] = React.useState([]);
    const [error, setError] = React.useState();
    const handleSaveAttachments = React.useCallback((selected) => __awaiter(this, void 0, void 0, function* () {
        try {
            setError(undefined);
            setIsLoading(true);
            setLoadingEmailAttachments(selected);
            const documentsResponse = yield alertsClient.saveDocuments(selected);
            setAttachments((prevState) => [...prevState, ...documentsResponse]);
            if (updateForm) {
                updateForm([...attachments, ...documentsResponse]);
            }
        }
        catch (error) {
            setError(error);
        }
        finally {
            setIsLoading(false);
            setLoadingEmailAttachments([]);
        }
    }), [attachments, alertsClient, updateForm]);
    const handleUpdateScanResults = React.useCallback((documentIds) => __awaiter(this, void 0, void 0, function* () {
        try {
            setError(undefined);
            const updatedDocuments = yield alertsClient.updateDocumentsScanResult(documentIds);
            const result = attachments
                .map((s) => updatedDocuments.find((t) => t.fileId == s.fileId) || s)
                .concat(updatedDocuments.filter((s) => !attachments.find((t) => t.fileId == s.fileId)));
            setAttachments(result);
            if (updateForm) {
                updateForm(result);
            }
        }
        catch (error) {
            setError(error);
        }
    }), [alertsClient, attachments, updateForm]);
    const handleScanAttachments = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const documents = attachments.filter((file) => {
            if (!file.virusScan || !file.virusScan.result) {
                return true;
            }
            return isEmpty(file.virusScan.result);
        });
        const documentIds = documents === null || documents === void 0 ? void 0 : documents.map((doc) => doc.fileId).filter((i) => !!i);
        if (documentIds.length) {
            yield handleUpdateScanResults(documentIds);
        }
    }), [attachments, handleUpdateScanResults]);
    const handleGetAttachment = React.useCallback((documentId, documentName) => __awaiter(this, void 0, void 0, function* () {
        try {
            setError(undefined);
            setIsLoading(true);
            const blob = yield alertsClient.getDocument(documentId);
            downloadBlob(blob, documentName);
        }
        catch (error) {
            setError(error);
        }
        finally {
            setIsLoading(false);
        }
    }), [alertsClient]);
    const handleRemoveAttachment = React.useCallback((document) => {
        const result = attachments.filter((ea) => ea !== document);
        setAttachments(result);
        if (updateForm) {
            updateForm(result);
        }
    }, [attachments, updateForm]);
    return {
        attachments,
        isLoading,
        loadingEmailAttachments,
        error,
        handleSaveAttachments,
        handleScanAttachments,
        handleGetAttachment,
        handleRemoveAttachment,
    };
}
function isEmpty(str) {
    return !str || str.length === 0 || !str.trim();
}
